var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-topic"},[_c('div',{staticClass:"left topic-left-items"},_vm._l((_vm.categoryList),function(item){return _c('router-link',{key:item.cate_id,staticClass:"topic-left-item",attrs:{"to":{
        name: item.cate_type == 2 ? 'topic_category' : 'topic_list',
        query:
          item.cate_type == 2
            ? {
                id: item.cate_id,
                cate_type: item.cate_type,
                name: item.name,
              }
            : {
                id: item.cate_id,
                cate_type: item.cate_type,
                name: item.name,
              },
      }}},[_c('img',{staticClass:"img",attrs:{"src":_vm._f("baseImg")(item.image)}}),_c('div',{staticClass:"tit z-line-1"},[_vm._v(_vm._s(item.name))])])}),1),_c('div',{staticClass:"right"},[_c('div',{staticClass:"topic-title"},[_vm._v("实时动态")]),_c('div',{staticClass:"topic-items"},_vm._l((_vm.list.slice(0, 5)),function(item){return _c('router-link',{key:item.id,staticClass:"topic-item z-line-1",attrs:{"to":{
          name: 'topic_detail',
          query: {
            id: item.id,
          },
        },"title":item.title}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1),(_vm.list.length > 5)?_c('div',{staticClass:"topic-items"},_vm._l((_vm.list.slice(5)),function(item){return _c('router-link',{key:item.id,staticClass:"topic-item z-line-1",attrs:{"to":{
          name: 'topic_detail',
          query: {
            id: item.id,
          },
        },"title":item.title}},[_vm._v(" "+_vm._s(item.title)+" ")])}),1):_vm._e(),(_vm.total)?_c('div',{staticClass:"z-pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.current_page,"page-size":_vm.per_page,"layout":"prev, pager, next","total":_vm.total},on:{"current-change":_vm.handleCurrentChange,"update:currentPage":function($event){_vm.current_page=$event},"update:current-page":function($event){_vm.current_page=$event},"update:pageSize":function($event){_vm.per_page=$event},"update:page-size":function($event){_vm.per_page=$event}}}),_c('span',{staticClass:"z-pagination__total"},[_vm._v(" 共 "+_vm._s(_vm.total)+" 条 ")])],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }